import script from "./rough_main.vue?vue&type=script&setup=true&lang=js"
export * from "./rough_main.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__